import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Logger } from 'src/app/services/logger/logger.service';
import { LoginService } from 'src/app/services/login/login.service';

const logger = new Logger('AuthGuard');

export const authGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  const loginService: LoginService = inject(LoginService);

  logger.info('Auth Guard functionality');
  if(loginService.isUserLoggedIn()){
    if(loginService.redirectUrl){
      router.navigate([loginService.redirectUrl]);
      loginService.redirectUrl = null;
    } 
    
    return true;
  } else {
    logger.info('Authendication failed');
    loginService.redirectUrl = state.url;
  }

  router.navigate(['login']);
  return false;
};
